import { render, staticRenderFns } from "./SSOSignIn.vue?vue&type=template&id=a2859c54&"
import script from "./SSOSignIn.vue?vue&type=script&lang=ts&"
export * from "./SSOSignIn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports